// extracted by mini-css-extract-plugin
export default {"form":"styles_form__Lh8Jc"};